import { apiCall, NEW_BE_API } from '../../utils/APIFunctions';

export function newGet() {
  return apiCall(`${NEW_BE_API}/api/n1/users/my`, "GET");
}

export function fetchAllCompanies() {
  return apiCall(`${NEW_BE_API}/api/n1/companies`, "GET");
}